/**
 * Installs a patient JWT (from `/patient/auth` or the statement lookup) as the
 * session the public landing pages call the API with. The lab session shares
 * the same slot, so it is cleared first rather than left half-overwritten.
 */
export const setPatientAccessToken = (accessToken: string) => {
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('lab_access_token')
  localStorage.removeItem('lab_refresh_token')
  localStorage.setItem('access_token', accessToken)
}
